import {
  ORDER_CONFIRMATION_PAGE_ROOT_CONTEXT_ID,
  ORDER_CONFIRMATION_PAGE_ROOT_CONTEXT_TYPE_ID,
  CONFIRMED_ORDER_BINDING_CONTEXT_ID,
} from './identifiers';

import type {
  BindingContextDef,
  BindingContextTypeDef,
  TypeReferenceBuilder,
  BindingContextRelationshipDef,
} from '@packages/systems/dynamo/source-types';

export const orderConfirmationPageRootContextType: BindingContextTypeDef = {
  entity: 'PageRoot',
  id: ORDER_CONFIRMATION_PAGE_ROOT_CONTEXT_TYPE_ID,
  label: 'Order Confirmation Page Root',
  iconName: 'product',
};

export function orderConfirmationPageRootContext<
  RootTRef,
  EntityTRef,
  ListTRef,
>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextDef<RootTRef, EntityTRef, ListTRef> {
  return {
    variant: 'Page',
    id: ORDER_CONFIRMATION_PAGE_ROOT_CONTEXT_ID,
    label: 'Order Confirmation',
    type: typeReferenceBuilder.entityOf({
      entity: 'PageRoot',
      id: ORDER_CONFIRMATION_PAGE_ROOT_CONTEXT_TYPE_ID,
    }),
    matchPage: (page) => page.utilKey === 'ecommerce-confirmation',
  };
}

export function orderConfirmationPageRelationships<
  RootTRef,
  EntityTRef,
  ListTRef,
>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextRelationshipDef<RootTRef, EntityTRef> {
  return {
    type: typeReferenceBuilder.entityOf({
      entity: 'PageRoot',
      id: ORDER_CONFIRMATION_PAGE_ROOT_CONTEXT_TYPE_ID,
    }),
    relativeContexts: [CONFIRMED_ORDER_BINDING_CONTEXT_ID],
  };
}
